// account_config stores values with Python's json.dumps(value); the 64 KiB
// column limit applies to that exact text, so the editor has to reproduce it.

export const MAX_CONFIG_BYTES = 65535

const SHORT_ESCAPES: Record<string, string> = {
  '"': '\\"',
  "\\": "\\\\",
  "\n": "\\n",
  "\r": "\\r",
  "\t": "\\t",
  "\b": "\\b",
  "\f": "\\f",
}

// Python's ESCAPE_ASCII: everything outside space..~ is escaped, per UTF-16 unit
const dumpString = (text: string): string =>
  `"${text.replace(/[\\"]|[^ -~]/g, (ch) => {
    return (
      SHORT_ESCAPES[ch] ??
      `\\u${ch.charCodeAt(0).toString(16).padStart(4, "0")}`
    )
  })}"`

export const pythonJsonDumps = (value: unknown): string => {
  if (value === null || value === undefined) return "null"
  if (typeof value === "string") return dumpString(value)
  if (typeof value === "number") return String(value)
  if (typeof value === "boolean") return value ? "true" : "false"
  if (Array.isArray(value)) return `[${value.map(pythonJsonDumps).join(", ")}]`
  if (typeof value === "object") {
    const items = Object.entries(value)
      .filter(([, item]) => item !== undefined)
      .map(([key, item]) => `${dumpString(key)}: ${pythonJsonDumps(item)}`)
    return `{${items.join(", ")}}`
  }
  throw new TypeError(`Cannot serialise ${typeof value} to JSON`)
}

export const fitsConfigLimit = (value: unknown): boolean =>
  // The dump is pure ASCII, so its length is its byte count
  pythonJsonDumps(value).length <= MAX_CONFIG_BYTES
